import { resolveAccessiblePath } from '../utils/resolveAccessiblePath';

class NavigationController {
    navigateSignup() {
        this.props.navigate('/signup');
    }

    navigateLogin() {
        this.props.navigate('/');
    }

    /**
     * "Take me to my home page" — used after login/signup/password-reset/
     * account-save. Lands on the first page the session's scopes actually
     * grant (Dashboard first, matching the sidebar's priority), never a
     * hardcoded /dashboard a scope-less role would immediately 403 on.
     */
    navigateDashboard() {
        const user = this.props.user ?? this.user ?? this.data?.user;
        const path = resolveAccessiblePath(user?.scopes);
        this.props.navigate(path);
    }

    navigateConfigurations() {
        this.props.navigate('/configurations');
    }

    navigateUser(userId) {
        this.props.navigate(`/users/user?userId=${userId}`);
    }

    navigateSupport() {
        if (this.props.navigate) this.props.navigate('/support/ticket');
    }

    navigateTicket(ticketId) {
        if (this.props?.navigate) {
            this.props.navigate(`/support/ticket/${encodeURIComponent(ticketId)}`);
        } else {
            window.location.href = `/support/ticket/${encodeURIComponent(ticketId)}`;
        }
    }

    navigateToAvailableBalance() {
        this.props.navigate('/configurations/available-balance');
    }

    /** Header bell → admin notification feed. */
    navigateNotifications() {
        if (this.props.navigate) this.props.navigate('/notifications');
    }

    navigateToReviewDetail(eventId) {
        if (this.props.navigate) {
            this.props.navigate(`/reviews/${encodeURIComponent(eventId)}`);
        }
    }

    navigateToReviews() {
        if (this.props.navigate) {
            this.props.navigate('/reviews');
        }
    }

    navigateUploadsSimulator() {
        if (this.props.navigate) {
            this.props.navigate('/uploads-simulator');
        }
    }
}

export default NavigationController;
